import { useState, useEffect } from 'react'

import { useEsri } from '../hooks'
import { useSelectedOverlays } from '../../overlays/hooks'

const esriReqs = ['esri/layers/MapImageLayer', 'esri/layers/FeatureLayer']

const OverlayLayer = ({ map, view }) => {
  const [ready, { MapImageLayer, FeatureLayer }] = useEsri(esriReqs)
  const overlays = useSelectedOverlays()
  const [data, setData] = useState({ ids: [], layers: {} })

  useEffect(() => {
    if (ready && map) {
      const idsToShow = overlays.map(o => o.id)
      const layerIdsToRemove = data.ids.filter(id => !idsToShow.includes(id))
      const layerIdsToAdd = idsToShow.filter(id => !data.ids.includes(id))

      if (layerIdsToAdd.length === 0 && layerIdsToRemove.length === 0) {
        return // no changes
      }

      // remove layer toggled off
      layerIdsToRemove.forEach(id => {
        map.remove(data.layers[id])
      })

      // start building new data
      let newData = { ids: idsToShow, layers: {} }
      overlays.forEach(overlay => {
        if (layerIdsToAdd.includes(overlay.id)) {
          const newLayer =
            overlay.type === 'feature'
              ? new FeatureLayer({
                  url: overlay.url,
                  popupTemplate: JSON.parse(overlay.popupTemplate)
                })
              : new MapImageLayer({ url: overlay.url })
          map.add(newLayer)
          newData.layers[overlay.id] = newLayer
        } else {
          newData.layers[overlay.id] = data.layers[overlay.id]
        }
      })
      setData(newData)
    }
  }, [ready, FeatureLayer, MapImageLayer, map, data, overlays])

  return null
}

export default OverlayLayer
